<script>
import {push} from './pt-router/Router.svelte'
import * as Common from './Common.js'

let newPassword = ''

export let code

function submit() {
    let resetPasswordRequest = {
        password: newPassword,
        code: code
    }
    Common.postData('reset-password', resetPasswordRequest)
    .then(r => {
        if(!r.ok) {
            alert("Problem reseting password")
            return
        }
        alert("Password successfully changed!")
        push('/')
    })
}
</script>

<h1>Reset Password</h1>
<p>
    Please enter a new password below:
</p>
<input type="password" placeholder="New Password" bind:value={newPassword}>
<button on:click={submit}>Submit</button>
